// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1qFQL","overflowing":"ReadFullNote_overflowing__3eATO"};